<template>
  <div class="fe-image-preview-component">
    <div v-if="imageList && imageList.length > 0">
      <el-image
        v-for="(item, index) in imageList"
        :key="index"
        :src="item.url || item"
        :lazy="item.lazy !== null ? item.lazy : lazy"
        :fit="item.fit !== null ? item.fit : fit"
        style="width: 100px; height: 100px"
        @click="showImage(item, index)"
      ></el-image>
    </div>
    <template v-else>
      <div v-if="showNoImage">
        <el-image src="" fit="fill" style="width: 100px; height: 100px">
          <template #error>
            <div class="el-image__error">
              <img src="../assets/img/wallet/ico32px_syetem_zwpt@2x.png" alt="" />
              <span>暂无图片</span>
            </div>
          </template>
        </el-image>
      </div>
    </template>
    <FeViewerNew v-model="viewerVisible" :data="viewerData" :options="viewerOptions"></FeViewerNew>
  </div>
</template>
<script>
import FeViewerNew from './FeViewerNew';

export default {
  name: 'FeImagePreview',
  components: {
    FeViewerNew
  },
  props: {
    imageList: {
      required: false,
      type: Array,
      default: () => {
        return [];
      }
    },
    lazy: {
      required: false,
      type: Boolean,
      default: false
    },
    fit: {
      required: false,
      type: String,
      default: 'fill'
    },
    multiple: {
      required: false,
      type: Boolean,
      default: true
    },
    showNoImage: {
      required: false,
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      viewerVisible: false,
      viewerOptions: {}, // 支持viewer插件所支持的选项
      viewerData: []
    };
  },
  methods: {
    showImage(item, idx) {
      let previewData = [];

      if (this.multiple) {
        previewData = this.imageList.map(el => {
          if (typeof el === 'string') {
            return { url: el, title: '预览图片' };
          } else {
            return { url: el.url, title: el.title || '预览图片' };
          }
        });
        this.viewerOptions = { initialViewIndex: idx }; // 多图预览索引
      } else {
        if (typeof item === 'string') {
          previewData.push({ url: item, title: '预览图片' });
        } else {
          previewData.push({ url: item.url, title: item.title || '预览图片' });
        }
      }
      this.viewerVisible = true;
      this.viewerData = previewData;
    }
  }
};
</script>
<style lang="postcss" scoped>
.el-image /deep/ .el-image__inner {
  cursor: pointer;
}
.el-image + .el-image {
  margin-left: 10px;
}
.el-image /deep/ .el-image__error {
  display: flex;
  flex-direction: column !important;
  font-size: 12px;
  color: #ccc;
  img {
    width: 32px;
    height: 32px;
    margin-bottom: 8px;
  }
}
</style>
